import { FooterConfig } from "./types";

const currentYear = new Date().getFullYear();

export const FOOTER_CONFIG: FooterConfig = {
  logo: {
    src: "/images/logo/logo.webp",
    alt: "Repayas",
    href: "/",
  },
  tagline:
    "Repayas helps UK small businesses know what is safe to spend by separating operating cash from VAT liability.",
  columns: [
    {
      id: "product",
      title: "Product",
      links: [
        {
          id: "how-it-works",
          label: "How it works",
          href: "/#how-it-works",
        },
        {
          id: "features",
          label: "Features",
          href: "/#product",
        },
        {
          id: "pricing",
          label: "Pricing",
          href: "/pricing",
        },
        {
          id: "faq",
          label: "FAQ",
          href: "/#faq",
        },
      ],
    },
    {
      id: "company",
      title: "Company",
      links: [
        {
          id: "privacy",
          label: "Privacy",
          href: "/privacy",
        },
        {
          id: "terms",
          label: "Terms",
          href: "/terms",
        },
        {
          id: "cookies",
          label: "Cookies",
          href: "/cookies",
        },
      ],
    },
  ],
  contact: {
    label: "Contact",
    email: "hello@repayas.com",
    href: "mailto:hello@repayas.com",
  },
  copyright: `© ${currentYear} Repayas. A product operated by Inovidia Limited.`,
  disclaimer:
    "Repayas is not a bank, does not provide financial advice, and does not file tax returns. Safe-to-Spend figures are estimates based on available data and should not be relied upon as financial advice. Always consult a qualified accountant.",
};
